import React from 'react';

export const ArrowUpIcon = (): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    aria-hidden
  >
    <g clipPath="url(#ella-arrow-up-clip)">
      <path
        d="M2 6L2.705 6.705L5.5 3.915V10H6.5V3.915L9.29 6.71L10 6L6 2L2 6Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="ella-arrow-up-clip">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
